// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const roleQueryPackManager = {
  id: "query-pack-manager",
  mrn: "//iam.api.mondoo.app/roles/query-pack-manager",
  title: "Query Pack Manager",
  allowedActions,
} as const;

export type RoleQueryPackManager = typeof roleQueryPackManager;
